import script from "./BaseTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTable.vue?vue&type=style&index=0&id=3b39ce0b&lang=css"

const __exports__ = script;

export default __exports__